module.exports = __webpack_public_path__ + "static/media/SAINT_4532.fac7e524.jpg";